<template>
  <div id="billing">
     <v-card-title class="pl-0 pr-0 pb-0">
          <v-layout wrap row class="mb-4" justify-space-between>
              <v-flex sm2 mt-3>
                <div class="text-xs-right">
                  <v-btn class="pf-btn pf-bg-teal">
                    <download-excel :data="AgencyAccountFilterList" :fields="exportFields" :name="exportExcelName">Export to Excel</download-excel>
                  </v-btn>
                </div>
              </v-flex>
              <v-flex sm2 mt-3>
                <div class="text-xs-right">
                      <v-btn
                      class="pf-btn pf-bg-teal"
                      :disabled="filterStatus === 'Pending' && selected.length ? false : true"
                      dark
                      small
                      @click="CreateInvoice"
                    >
                      <span> Create Invoice </span>
                    </v-btn>
                </div>
              </v-flex>
              <v-flex sm2 mt-3 pl-1>
                <v-select
                  width="100"
                  class="filter_left pt-0"
                  v-model="filterStatus" 
                  label="Filter by status"
                  :items="statusListAll"
                  @change="updateList"
                  >
                </v-select>
              </v-flex>
              <v-flex sm2 mt-3>
                <v-select
                  class="pt-0"
                  v-model="selectDate"
                    label="select Date"
                  :items="dateFilterList"
                ></v-select>
              </v-flex>
              <v-flex sm3 pl-3 mt-1>
                  <v-text-field
                    v-model="search"
                    append-icon="search"
                    label="Search by Agency Name"
                    single-line
                    hide-details
                    ></v-text-field>
                </v-flex>
            </v-layout>
      </v-card-title>
      <v-layout class="mb-3">
        <v-flex class="pf-menu-text text-xs-right pf-text-teal">
          Total number of families: <b>{{ totalNumOfFamilies }}</b>, &nbsp;
          Total amount: <b>$ {{ totalAmount }}</b> &nbsp;&nbsp;
        </v-flex>
      </v-layout>
      <v-card-title class="pl-0 pr-0 pt-0">
        <v-layout wrap row justify-space-between>
          <v-flex sm12>
            <span v-show="filterStatus === 'Pending'">Note: Please select atleast one agency to create Invoice</span>
          </v-flex>
        </v-layout>
      </v-card-title>
    <v-card>
      <v-data-table
        v-model="selected"
        :headers="headers"
        item-key="agency_id"
        :items="AgencyAccountFilterList"
        :search="search"
        select-all
        ref="sortableTable"
        no-data-text="No results found"
        :pagination.sync="pagination"
        class="pf-data-table"
      >
      <template v-slot:headers="props">
          <tr>
            <th width="50px" v-if="filterStatus === 'Pending'">
                <v-checkbox
                :input-value="props.all"
                :indeterminate="props.indeterminate"
                primary
                hide-details
                @click.stop="toggleAll"
              ></v-checkbox>
            </th>
            <th
              v-for="header in props.headers"
              :key="header.text"
              aria-sort="none"
              class="text-xs-left"
              :class="[header.text === 'Status' ? 'text-xs-center' : header.text === '' ? 'text-xs-right' :'text-xs-left']"
            >
              {{ header.text }}
            </th>
          </tr>
        </template>
        <template v-slot:items="props">
          <tr>
            <td width="50px" v-if="filterStatus === 'Pending'" align="right" :active="props.selected" @click="props.selected = !props.selected">
              <v-checkbox :input-value="props.selected" primary hide-details></v-checkbox>
            </td>
            <td>{{ props.item.agency_name }}</td>
            <td style="font-size: 12px !important" v-if="props.item.memberships.length">
              <ol style="padding: 5px 0 5px 14px;">
                <li v-for="(membership, m) in props.item.memberships" :key="m">
                  {{ `${membership.name} - $ ${membership.amount}` }}
                </li>
              </ol>
            </td>
            <td v-else>default</td>
            <td>{{ props.item.account.length }}
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <span v-on="on">
                    <v-btn icon class="ma-0" @click="viewFamilyList(props.item)" small>
                      <v-icon size="22" color="grey darken-2" >visibility</v-icon>
                    </v-btn>
                  </span>
                </template>
                <span>View</span>
              </v-tooltip>
            </td>
            <td>{{ props.item.billing_month }}</td>
            <td>{{ props.item.billing_year }}</td>
            <td>{{ props.item.status === 'Paid' ? props.item.amount_paid : props.item.amount_tobe_paid }}</td>
            <td v-if="props.item.status === 'Not Paid'" align="center" width="160px">
              <v-layout justify-center>
                <v-select
                class="pt-0"
                  v-model="props.item.status"
                  :items="statusList"
                  @change="statusChange(props.item)"
                ></v-select>
              </v-layout>
            </td>
            <td align="center" v-else> {{ props.item.status }}</td>
            </tr>
        </template>
      </v-data-table>
    </v-card>
    <template>
      <div class="text-xs-center">
        <v-dialog
          v-model="isViewActive"
          width="700"
        >
          <v-card>
            <v-card-title
              class="pf-bg-teal pf-pos-relative headline white--text"
            >
              View &nbsp; <small>-&nbsp; {{ selectedAgency.name }}</small>
              <v-btn class="pf-icon-top-right" icon dark @click="isViewActive = false">
                <v-icon>close</v-icon>
              </v-btn>
            </v-card-title>
            <v-card-text>
              <app-view v-if="selectedAgency.account && selectedAgency.account.length" :data="selectedAgency"></app-view>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="white"
                flat
                @click="isViewActive = false"
                class="pf-bg-pink"
              >
                Close
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
    </template>
    <template>
      <div class="text-xs-center">
        <v-dialog
          v-model="isPaymentDateSelect"
          width="700"
          :persistent="true"
        >
          <v-card>
            <v-card-title>
              <span class="headline">Select the Payment Date</span>
            </v-card-title>
            <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 sm6 md4>
                    <v-menu
                  :close-on-content-click="true"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  max-width="290px"
                  min-width="290px"
                >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="selectedAgency.selected_payment_date"
                        label="Payment Date"
                        hint="MM/DD/YYYY"
                        persistent-hint
                        readonly 
                        clearable
                        prepend-icon="event"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker color="#019d8c" :max="new Date().toISOString().substr(0, 10)" @input="PaymentDateSelection" v-model="selectedAgency.selected_payment_date"></v-date-picker>
                  </v-menu>
                </v-flex>
              </v-layout>
            </v-container>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn class="pf-btn pf-btn-cancel" flat="flat" @click.native="updateList()">
                  <v-icon size="16" class="pr-1">cancel</v-icon>
                  <div>Cancel</div>
                </v-btn>
              </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
    </template>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
/* global session store config moment */
import swal from 'sweetalert2';
import { getCollection, formatDate, update, create } from '../../helpers/helpers';
import appView from '../Invoices/view';
import JsonExcel from 'vue-json-excel';

export default {
  name: 'Invoices',
  components: {
    appView,
    'downloadExcel': JsonExcel
  },
  data: () => ({
    config: config,
    statusListAll: ['Pending', 'Not Paid', 'Paid'],
    statusList: ['Not Paid', 'Paid'],
    filterStatus: 'Pending',
    AgencyAccountFilterList: [],
    isViewActive: false,
    isPaymentDateSelect: false,
    selectedAgency: [],
    selected: [],
    selectDate: 'Last Month',
    dateFilterList: ['Last Month'],
    search: '',
    headers: [
      { text: 'Name', value: 'agency_name', sortable: false, align: 'left' },
      { text: 'Memberships', value: 'memberships', sortable: false, align: 'left' },
      { text: 'No of Families', sortable: false, value: '' },
      { text: 'Month', value: 'billing_month', sortable: false },
      { text: 'Year', value: 'billing_year', sortable: false },
      { text: 'Amount', value: 'amount', sortable: false },
      { text: 'Status', value: 'status', sortable: false, align: 'center', width: '160px' },
    ],
    pagination: {
      rowsPerPage: config.dom.rowsPerPage,
      sortBy: 'name'
    },
    exportFields: {
      'Agency Name': {
        callback: (value) => {
          return value.agency_name;
        }
      },
      'No of Families': {
        callback: (value) => {
          return value.account.length;
        }
      },
      'Month': {
        callback: (value) => {
          return value.billing_month;
        }
      },
      'Year': {
        callback: (value) => {
          return value.billing_year;
        }
      },
      'Amount': {
        callback: (value) => {
          return value.status === 'Paid' ? value.amount_paid : value.amount_tobe_paid;
        }
      },
      'Status': {
        callback: (value) => {
          return value.status;
        }
      }
    },
    totalNumOfFamilies: 0,
    totalAmount: 0
  }),
  computed: {
    ...mapGetters(['AgencyAccount']),
    exportExcelName () {
      return 'PF_Invoices_' + moment().tz(config.timezone).format('MM_DD_YYYY');
    }
  },
  beforeRouteEnter (to, from, next) {
    if (!session.isOnline()) {
      next({ path: '/login' });
    } else {
      next();
    }
  },
  async created () {
    await this.getInvoicesList();
    await this.updateList();
  },
  methods: {
    PaymentDateSelection () {
      this.isPaymentDateSelect = false;
      this.updateInvoice(this.selectedAgency);
    },
    updateList () {
      this.isPaymentDateSelect = false;
      this.selected = [];
      this.AgencyAccountFilterList = JSON.parse(JSON.stringify(this.AgencyAccount));
      this.AgencyAccountFilterList = this.AgencyAccountFilterList.filter(account => (account.status === this.filterStatus));
      this.totalNumOfFamilies = this.AgencyAccountFilterList.map(a => a.account.length);
      this.totalNumOfFamilies = this.totalNumOfFamilies.length ? this.totalNumOfFamilies.reduce((c, d) => c + d) : 0;
      this.totalAmount = this.AgencyAccountFilterList.map(a => a.amount_tobe_paid);
      this.totalAmount = this.totalAmount.length ? this.totalAmount.reduce((c, d) => c + d) : 0;

      console.log('totalNumOfFamilies', this.totalNumOfFamilies);
      console.log('totalAmount', this.totalAmount);
    },
    async CreateInvoice () { // multiple invoice create
      let payload = this.selected.map(agency => ({
        agency: agency.agency_id,
        amount: agency.amount_tobe_paid,
        account: agency.account.map(account => account._id),
        status: 'Not Paid',
        billing_year: agency.billing_year,
        billing_month: agency.billing_month,
      }));
      let { error, data } = await create('Invoices', { data: payload });
      if (error) {
        console.log(error);
      } else {
        for (let index = 0; index < data.length; index++) {
          let AgencyAccountIndex = this.AgencyAccount.findIndex(agency => agency.agency_id === data[index].agency);
          if (index !== -1) {
            this.AgencyAccount[AgencyAccountIndex].status = 'Not Paid';
            this.AgencyAccount[AgencyAccountIndex].invoice_date = data[index].invoice_date;
            this.AgencyAccount[AgencyAccountIndex].invoice_created = data[index].invoice_created;
            this.AgencyAccount[AgencyAccountIndex].invoice_id = data[index]._id;
          }
        }
        this.updateList();
        swal.fire({
          type: 'success',
          title: 'Invoices created successfully',
          showConfirmButton: false,
          timer: 2500,
        });
      }

    },
    async updateInvoice (item) {
      let payloadItem = JSON.parse(JSON.stringify(item));
      let payload = {
        agency: payloadItem.agency_id,
        amount: payloadItem.amount_tobe_paid,
        account: payloadItem.account.map(account => account._id),
        status: payloadItem.status,
        invoice_created: payloadItem.invoice_created,
        billing_year: payloadItem.billing_year,
        billing_month: payloadItem.billing_month,
        invoice_date: formatDate(payloadItem.invoice_date, 'YYYY-MM-DD'),
        payment_date: payloadItem.selected_payment_date
      };
      let { error, data } = await update('Invoice', payload, payloadItem.invoice_id);
      if (error) {
        console.log(error);
      } else {
        let editIndex = this.AgencyAccount.findIndex(agency => agency.agency_id === item.agency_id);
        this.AgencyAccount[editIndex].status = 'Paid';
        this.AgencyAccount[editIndex].payment_date = payloadItem.selected_payment_date;
        this.AgencyAccount[editIndex].amount_paid = payloadItem.amount_tobe_paid;
        store.commit('setAgencyAccount', this.AgencyAccount);
        this.updateList();
        swal.fire({
          type: 'success',
          title: 'Invoice status updated successfully',
          showConfirmButton: false,
          timer: 2500,
        });
      }
    },
    toggleAll () {
      if (this.selected.length) this.selected = [];
      else this.selected = this.AgencyAccountFilterList.slice();
    },
    viewFamilyList (item) {
      this.isViewActive = true;
      this.selectedAgency = [];
      this.selectedAgency = item;
    },
    statusChange (item) {
      this.isPaymentDateSelect = true;
      this.selectedAgency = [];
      this.selectedAgency = item;
    },
    async getInvoicesList () {
      if (!this.AgencyAccount.length) {
        let { error, data } = await getCollection('Invoice/ListByAgency', true);
        if (error) {
          console.log(error);
        } else {
          if (data.length > 0) {
            store.commit('setAgencyAccount', data);
          }
        }
      }
    },
    formatDate (dateString) {
      if (dateString) {
        return formatDate(dateString, 'MM/DD/YYYY');
      }
    }
  }
};
</script>
<style scoped lang="css">
#billing >>> .v-select__selection {
    width: 100%;
    justify-content: center;
    padding-left: 20px;
}

#billing >>> .accent--text {
    color: #019d8c !important;
    caret-color: #019d8c !important;
}

.theme--dark.v-btn.v-btn--disabled:not(.v-btn--icon):not(.v-btn--flat):not(.v-btn--outline) {
  background-color: lightgray !important;
  color: #fff !important;
}

</style>



// WEBPACK FOOTER //
// src/pages/Invoices/list.vue